import { RootState } from "store/index";

const foodItemFull = (state: RootState) => state.foodItemDetail.foodItemFull;

const foodItemBasic = (state: RootState) => state.foodItemDetail.foodItem;

const foodTags = (state: RootState) => state.foodItemDetail.foodTags;

const foodNutritionRecords = (state: RootState) =>
  state.foodItemDetail.foodNutritionRecords;

const foodRecipes = (state: RootState) => state.foodItemDetail.foodRecipes;

const foodSuppliers = (state: RootState) => state.foodItemDetail.foodSuppliers;

const equivalentFoodItems = (state: RootState) =>
  state.foodItemDetail.equivalentFoodItems;

const variantFoodItems = (state: RootState) =>
  state.foodItemDetail.variantFoodItems;

const usedAsIngredientIn = (state: RootState) =>
  state.foodItemDetail.usedAsIngredientIn;

const usedInMenus = (state: RootState) => state.foodItemDetail.usedInMenus;

const usedInMenuLoops = (state: RootState) =>
  state.foodItemDetail.usedInMenuLoops;

const foodIsLoading = (state: RootState) => state.foodItemDetail.isLoading;

const foodApprovalIsChanging = (state: RootState) =>
  state.foodItemDetail.isApprovalChanging;

const foodError = (state: RootState) => state.foodItemDetail.error;

export default {
  foodItemFull,
  foodItemBasic,
  foodTags,
  foodNutritionRecords,
  foodRecipes,
  foodSuppliers,
  equivalentFoodItems,
  variantFoodItems,
  usedAsIngredientIn,
  usedInMenus,
  usedInMenuLoops,
  foodIsLoading,
  foodApprovalIsChanging,
  foodError,
};
